import { createBreakpoints } from '@mui/system';
const breakpoints = createBreakpoints({
    values: {
        //default
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
    },
});
const commonTypographyProps = {
    fontFamily: '"Zurich Sans", "Helvetica Neue", Arial, sans-serif',
    fontStyle: 'normal',
    variant: 'body1',
};
const commonBody1Props = {
    fontSize: '14px',
    lineHeight: '20px',
    variant: 'body1',
    [breakpoints.up('sm')]: {
        fontSize: '16px',
        lineHeight: '24px',
    },
};
const commonBody2Props = {
    fontSize: '14px',
    lineHeight: '20px',
    variant: 'body2', // TODO mobile-friendly (breakpoint same as above for commonBody1Props)
};
const commonCaptionProps = {
    fontSize: '12px',
    lineHeight: 'normal',
    variant: 'caption',
};
export const components = {
    DSButton: {
        sizes: {
            small: {
                borderRadius: '28px',
                height: 36,
                iconSize: 14,
                '& .MuiTypography-root': {
                    fontSize: 14,
                    fontWeight: 300,
                    lineHeight: '20px',
                },
                '& .MuiStack-root': {
                    gap: '4px',
                },
                '& .MuiIcon-root': {
                    fontSize: '14px',
                },
            },
            medium: {
                borderRadius: '28px',
                height: 44,
                iconSize: 16,
                '& .MuiTypography-root': {
                    fontSize: 16,
                    fontWeight: 300,
                    lineHeight: '24px',
                },
                '& .MuiStack-root': {
                    gap: '6px',
                },
                '& .MuiIcon-root': {
                    fontSize: '16px',
                },
            },
            large: {
                borderRadius: '28px',
                fontSize: 18,
                fontWeight: 400,
                lineHeight: '24px',
                height: 46,
                iconSize: 18,
                '& .MuiTypography-root': {
                    fontSize: 18,
                    fontWeight: 400,
                    lineHeight: '24px',
                },
                '& .MuiStack-root': {
                    gap: '8px',
                },
                '& .MuiIcon-root': {
                    fontSize: '18px',
                },
            },
            'x-large': {
                borderRadius: '28px',
                height: 52,
                iconSize: 20,
                '& .MuiTypography-root': {
                    fontSize: 20,
                    fontWeight: 400,
                    lineHeight: '24px',
                },
                '& .MuiStack-root': {
                    gap: '8px',
                },
                '& .MuiIcon-root': {
                    fontSize: '22px',
                },
            },
        },
        variants: {
            text: {
                padding: '0',
            },
            contained: {},
            outlined: {},
        },
    },
    DSIcon: {
        sizes: {
            small: {
                fontSize: 12,
                height: '16px',
                width: '16px',
            },
            medium: {
                fontSize: 20,
                height: '24px',
                width: '24px',
            },
            large: {
                fontSize: 27,
                height: '32px',
                width: '32px',
            },
        },
    },
    DSTypography: {
        variants: {
            display: {
                ...commonTypographyProps,
                fontFamily: 'Ogg',
                fontSize: '32px',
                fontWeight: '400',
                lineHeight: 'normal',
            },
            h1: {
                ...commonTypographyProps,
                fontSize: '32px',
                fontWeight: '300',
                lineHeight: 'normal',
                variant: 'h1',
            },
            h2: {
                ...commonTypographyProps,
                fontSize: '28px',
                fontWeight: '300',
                lineHeight: 'normal',
                variant: 'h2',
            },
            h3: {
                ...commonTypographyProps,
                fontSize: '20px',
                fontWeight: '300',
                lineHeight: 'normal',
                variant: 'h3',
            },
            h4: {
                ...commonTypographyProps,
                fontSize: '20px',
                fontWeight: '300',
                lineHeight: '30px',
                variant: 'h4',
            },
            h5: {
                ...commonTypographyProps,
                fontSize: '20px',
                fontWeight: '500',
                lineHeight: '30px',
                variant: 'h5',
            },
            button: {
                ...commonTypographyProps,
                fontSize: '20px',
                fontWeight: '400',
                lineHeight: '20px',
                variant: 'button',
            },
            'body1 light': {
                ...commonTypographyProps,
                ...commonBody1Props,
                fontWeight: '300',
            },
            'body1 regular': {
                ...commonTypographyProps,
                ...commonBody1Props,
                fontWeight: '400',
            },
            'body1 medium': {
                ...commonTypographyProps,
                ...commonBody1Props,
                fontWeight: '500',
            },
            'body1 semibold': {
                ...commonTypographyProps,
                ...commonBody1Props,
                fontWeight: '600',
            },
            'body2 light': {
                ...commonTypographyProps,
                ...commonBody2Props,
                fontWeight: '300',
            },
            'body2 regular': {
                ...commonTypographyProps,
                ...commonBody2Props,
                fontWeight: '400',
            },
            'body2 medium': {
                ...commonTypographyProps,
                ...commonBody2Props,
                fontWeight: '500',
            },
            'body2 semibold': {
                ...commonTypographyProps,
                ...commonBody2Props,
                fontWeight: '600',
            },
            'caption regular': {
                ...commonTypographyProps,
                ...commonCaptionProps,
                fontWeight: '400',
            },
            'caption medium': {
                ...commonTypographyProps,
                ...commonCaptionProps,
                fontWeight: '500',
            },
        },
    },
};
